import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const createDealForV2Customer = (treeId, payload, callback) => {
  return async (dispatch) => {
    dispatch({ type: 'CREATING_DEAL_FOR_V2_CUSTOMER' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.post(
            `/ads/discovery-tree/${treeId}/deals`,
            payload,
            {
              params: {
                requestId: reqId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
                // 'x-api-version': 'v2',
              },
            },
          );
          if (response.status === 200) {
            await dispatch({
              type: 'CREATING_DEAL_FOR_V2_CUSTOMER_DONE',
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'CREATING_DEAL_FOR_V2_CUSTOMER_FAILED',
              payload: `Failed to create deal for v2 customer`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'CREATING_DEAL_FOR_V2_CUSTOMER_FAILED',
            payload: `Failed to create deal for v2 customer`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'CREATING_DEAL_FOR_V2_CUSTOMER_FAILED',
        payload: `Failed to create deal for v2 customer`,
      });
    }
  };
};

export default createDealForV2Customer;
